import {WebcamErrorType, type WebcamErrorDetails} from '@chekinapp/ui';
import {ANALYTIC_EVENTS, Analytics} from '../analytics';
import {safeCaptureException} from './sentry';

const EXPECTED_CAMERA_ERRORS: WebcamErrorType[] = [
  WebcamErrorType.Permission,
  WebcamErrorType.NotFound,
];

const MAX_TAG_LENGTH = 200;

function reportCameraError(error: WebcamErrorDetails, context: string) {
  Analytics.track(ANALYTIC_EVENTS.ivCameraUnavailable, {
    Context: context,
    'Error kind': error.type,
    'Error message': error.message,
  });

  if (EXPECTED_CAMERA_ERRORS.includes(error.type)) return;

  safeCaptureException(new Error(`Camera unavailable: ${error.type}`), undefined, {
    area: 'identity-verification',
    camera_error: error.type,
    capture_context: context,
    camera_message: error.message.slice(0, MAX_TAG_LENGTH),
  });
}

export {reportCameraError};
